module.exports = __webpack_public_path__ + "img/thumbnail_AmericanFlamingo_j_normal.b6a8053d.png";